import React from "react";
import AboutContent from './AboutContent'
import AboutBanner from './AboutBanner'


const AboutSection = () => {
	
	
  return (
    <div id="about" className='bg-black w-full h-full flex flex-col items-center justify-center pt-8 md:pt-0'>
        
        {/* -------------------------------- ABOUT US -------------------------------- */}
        <AboutContent
            heading="What is this club"
            grayHeading=" about?"
            boldText="Welcome to the VIT Chennai Data Science Club!"
            text=" Our club is an initiative aimed at promoting data literacy, fostering innovation, and creating a platform for data-driven discussions and collaborations. Established in 2020, we are a dynamic community of data enthusiasts passionate about exploring the fascinating world of data science. Whether you're a data professional or just beginning your journey, our club offers a vibrant community and exciting opportunities to fuel your passion for data." 
        />

        {/* ------------------------------ MEMBERS PHOTO ----------------------------- */}
        <AboutBanner/>

        {/* ------------------------- MISSIONS AND OBJECTIVE ------------------------- */}
        <AboutContent
			heading="Mission &"
			grayHeading=" Objective"
			boldText="Our mission is to empower students with practical data science skills, promote interdisciplinary learning."
			text=" We strive to organize impactful events, workshops, and hackathons that enhance our members' data science knowledge, foster a collaborative environment, and prepare them for real-world data challenges."
		/>
		<hr className="h-px w-[80%] my-8 border-0 bg-secondary"/>
    </div>
  )
}

export default AboutSection